import { createContext } from "react";

const WorkflowContext = createContext();

export default WorkflowContext;
